<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5 class="card-title">Aufgaben</h5>
          </div>
          <div class="col-md-auto text-right">
            <p-button type="success" @click="newTask" class="mt-0"><i class="bi bi-file-earmark-plus"></i> Neue Aufgabe</p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-collapse accordion>
            <el-collapse-item :name="task.key" v-for="task in tasks" :key="task.key">
              <template slot="title">
                <p class="pl-2 mt-3" style="font-size: 1.2em;"><i class="bi bi-circle" v-if="task.taskStatus != 'Erledigt'"></i><i class="bi bi-check-circle" v-if="task.taskStatus == 'Erledigt'"></i> <b> {{task.taskName}} </b> <small> ({{ task.taskCreatedAtFormatted }})</small></p>
              </template>
              <div class="row pl-5">
                <div class="col-md-12">
                  <p class="mb-1"><b>Beschreibung:</b></p>
                  <p style="white-space: pre-line;">{{ task.taskDescription }}</p>
                </div>
              </div>
              <div class="row pl-5">
                <div class="col-md-6">
                  <p><b>Zu erledigen bis:</b> {{ task.taskDueDateFormatted }}</p>
                </div>
                <div class="col-md-6">
                  <p><b>Bearbeiter:</b> {{ task.taskAssignee }}</p>
                </div>
              </div>
              <div class="row pl-5">
                <div class="col-md-12">
                  <p v-if="task.taskStatus == 'Erledigt'"><b>Status: </b>{{ task.taskStatus }} <i class="bi bi-check-circle"></i> <small>({{ task.taskCompletedAt }})</small></p>
                </div>
              </div>
              <div class="row pl-5" v-if="task.taskComment && task.taskComment.length > 0 && task.taskStatus == 'Erledigt'">
                <div class="col-md-12">
                  <p class="mb-1"><b>Anmerkung: </b></p>
                  <p style="white-space: pre-line;">{{ task.taskComment }}</p>
                </div>
              </div>

              <div class="row pl-3 pb-3">
                <div class="col-md-12 text-right">
                  <p-button
                    type="primary"
                    size="md"
                    @click="setTaskDone(task)"
                    :disabled="task.taskStatus === 'Erledigt'"
                  >
                    <i class="bi bi-check2-square"></i> Erledigt
                  </p-button>
                  <p-button
                    type="default"
                    size="md"
                    title="Aufgabe bearbeiten"
                    @click="editTask(task)"
                    :disabled="task.taskStatus === 'Erledigt'"
                  >
                    <i class="bi bi-pencil"></i>
                  </p-button>
                  <p-button
                    type="danger"
                    size="md"
                    title="Aufgabe löschen"
                    @click="removeTask(task.key, task.taskName)"
                  >
                    <i class="bi bi-trash"></i>
                  </p-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <small class="text-muted"><i><b>Hinweis:</b> Erledigte Aufgaben werden nach 7 Tagen automatisch ausgeblendet.</i></small>

    <!-- Neue Aufgabe Modal -->
    <el-dialog :title=" dialogMode === 'create' ? 'Neue Aufgabe erstellen' : 'Aufgabe bearbeiten'" :visible.sync="newTaskDialog" :close-on-click-modal="false">
      <el-form :model="newTaskForm">
        <div class="row">
          <div class="col-md-12">
              <el-form-item label="Titel">
                <el-input v-model="newTaskTitle" placeholder="Titel der Aufgabe" required></el-input>
              </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
              <el-form-item label="Beschreibung">
                <el-input
                  type="textarea"
                  v-model="newTaskDescription"
                  placeholder="Beschreibung der Aufgabe"
                  rows="4"
                ></el-input>
              </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <el-form-item label="Zu erledigen bis">
              <el-date-picker
                    v-model="newTaskDueDate"
                    type="date"
                    placeholder="Fälligkeitsdatum"
                    :picker-options="pickerOptions1"
                    format="dd.MM.yyyy"
                  >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item label="Bearbeiter">
              <el-select
                    class="select"
                    placeholder="Mitarbeiter wählen"
                    filterable
                    v-model="newTaskAssignee"
                  >
                    <el-option
                      v-for="option in staff"
                      class="select"
                      :value="option.staffName"
                      :label="option.staffName"
                      :key="option.staffName"
                    >
                    </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="newTaskDialog = false">Abbrechen</p-button>
        <p-button type="primary" @click="addTask" :disabled="!newTaskTitle" v-if="dialogMode === 'create'">Speichern</p-button>
        <p-button type="primary" @click="updateTask" :disabled="!newTaskTitle" v-if="dialogMode === 'edit'">Speichern</p-button>
      </span>
    </el-dialog>

    <!-- Add comment dialog -->
    <el-dialog title="Aufgabe erledigen" :visible.sync="commentDialog" :close-on-click-modal="false">
      <el-form :model="commentForm">
        <div class="row">
          <div class="col-md-12">
              <el-form-item label="Anmerkung">
                <el-input
                  type="textarea"
                  v-model="commentForm.comment"
                  placeholder="Füge eine Anmerkung hinzu..."
                  rows="3"
                ></el-input>
              </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="commentDialog = false">Abbrechen</p-button>
        <p-button type="primary" @click="markTaskDone">Erledigt</p-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Select, Option, Input, InputNumber, Collapse, CollapseItem, MessageBox, Dialog, Form, FormItem } from "element-ui";
import router from "../../../../main";
import moment from "moment-timezone";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);


export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    MessageBox,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },

  data() {
    return {
      tasks: [],
      staff: [],
      newTaskTitle: null,
      newTaskDescription: null,
      newTaskDueDate: null,
      newTaskAssignee: null,
      newTaskForm: {},
      editTaskKey: null,
      newTaskDialog: false,
      commentDialog: false,
      commentForm: { comment: "" },
      activeTaskKey: null,
      dialogMode: "create",
      location: store.getters.userlocation,
      role: store.getters.userrole,
      pickerOptions1: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Morgen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Woche",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 2 Wochen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Monat",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    this.loadTasks();
    this.getStaff();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadTasks();
      }
    );
  },
  methods: {
    loadTasks() {
      const tasksRef = db.collection("tasks");
      tasksRef.where('locationID', '==', this.location).where('Hidden', '==', false).orderBy("CreatedAt", "desc").onSnapshot((snapshotChange) => {
        this.tasks = [];
        snapshotChange.forEach((doc) => {
          if (doc.data().DueDate && doc.data().DueDate.toDate) {
            doc.data().DueDate = doc.data().DueDate.toDate().toLocaleDateString("de-DE");
          }
          this.tasks.push({
            key: doc.id,
            taskName: doc.data().Title,
            taskDescription: doc.data().Description || "-",
            taskDueDate: doc.data().DueDate,
            taskDueDateFormatted: doc.data().DueDate ? moment(new Date(doc.data().DueDate.seconds * 1000)).format("DD. MMM YYYY").toString() : "-",
            taskAssignee: doc.data().Assignee || "-",
            taskStatus: doc.data().Status,
            taskComment: doc.data().Comment,
            taskCreatedAt: doc.data().CreatedAt,
            taskCreatedAtFormatted: moment(new Date(doc.data().CreatedAt.seconds * 1000)).format("DD. MMM YYYY").toString(),
            taskCompletedAt: doc.data().CompletedAt ? moment(new Date(doc.data().CompletedAt.seconds * 1000)).format("DD. MMM YYYY").toString() : null,
          });
        });
      });
    },
    getStaff() {
      // get list of staff
      const staffRef = db.collection("trainer");
      staffRef
        .orderBy("Name")
        .onSnapshot((snapshotChange) => {
          this.staff = [];
          snapshotChange.forEach((doc) => {
            this.staff.push({
              staffName: doc.data().Name,
            });
          });
        });
    },
    newTask() {
      this.dialogMode = "create";
      this.newTaskDialog = true;
      this.newTaskTitle = null;
      this.newTaskDescription = null;
      this.newTaskDueDate = null;
      this.newTaskAssignee = null;
    },
    editTask(task) {
      this.dialogMode = "edit";
      this.newTaskTitle = task.taskName;
      this.newTaskDescription = task.taskDescription;
      this.newTaskDueDate = task.taskDueDate;
      this.newTaskAssignee = task.taskAssignee;
      this.editTaskKey = task.key;
      this.newTaskDialog = true;
    },
    removeTask(taskKey, taskName) {
      MessageBox.confirm(
        "Soll die Aufgabe " + taskName + " wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              db.collection("tasks").doc(taskKey).update({ Hidden: true }).then(() => {
                console.log("Aufgabe " + taskName + " removed.");
                this.loadTasks()
              }).catch(() => {
                console.log("Error removing task.");
              });
            }
          },
        }
      );
    },
    addTask() {
      db.collection("tasks")
        .add({
          Title: this.newTaskTitle,
          Description: this.newTaskDescription,
          DueDate: this.newTaskDueDate,
          Assignee: this.newTaskAssignee,
          CreatedAt: new Date(),
          LastUpdated: new Date(),
          CompletedAt: null,
          Status: "offen",
          Hidden: false,
          locationID: this.location,
        })
        .then(() => {
          this.newTaskTitle = null;
          this.newTaskDescription = null;
          this.newTaskDueDate = null;
          this.newTaskAssignee = null;
          this.newTaskDialog = false;
          console.log("Task added.");
        })
        .catch(() => {
          console.log("Adding task failed");
        });
    },
    updateTask() {
      db.collection("tasks")
        .doc(this.editTaskKey)
        .update({
          Title: this.newTaskTitle,
          Description: this.newTaskDescription,
          DueDate: this.newTaskDueDate,
          Assignee: this.newTaskAssignee,
          LastUpdated: new Date(),
        })
        .then(() => {
          this.newTaskTitle = null;
          this.newTaskDescription = null;
          this.newTaskDueDate = null;
          this.newTaskAssignee = null;
          this.editTaskKey = null;
          this.newTaskDialog = false;
          console.log("Task updated.");
        })
        .catch(() => {
          console.log("Updating task failed");
        });
    },
    setTaskDone(task) {
      this.activeTaskKey = task.key;
      this.commentForm.comment = "";
      this.commentDialog = true;
    },
    markTaskDone() {
      db.collection("tasks")
        .doc(this.activeTaskKey)
        .update({
          Status: "Erledigt",
          Comment: this.commentForm.comment,
          CompletedAt: new Date(),
          LastUpdated: new Date(),
        })
        .then(() => {
          this.commentForm.comment = "";
          this.activeTaskKey = null;
          this.commentDialog = false;
          console.log("Task marked as done.");
        })
        .catch(() => {
          console.log("Marking task as done failed");
        });
    },
  },
};
</script>
<style>
  .el-form-item__label {
    font-weight: bold;
    line-height: normal !important;
  }
</style>
